import React from 'react';
import { StyledCenteredCircularProgress } from 'Components/CenteredCircularProgress/styles';

export default function CenteredCircularProgress() {
  return <StyledCenteredCircularProgress />;
}
